import { render, staticRenderFns } from "./ViewFile.vue?vue&type=template&id=6f44eb86&"
import script from "./ViewFile.vue?vue&type=script&lang=js&"
export * from "./ViewFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports